import { FunctionAPI, Function } from '../../api/functions'

const state = {
  all: [],
  current: ''
}

const getters = {}

const actions = {
  getAllFunctions ({ commit, dispatch }: any, ns: string) {
    FunctionAPI.getAll(ns, f => {
      commit('setFunctions', f)
      dispatch('updateFnPackage')
    })
  },
  selectFunction ({ commit, dispatch, state }: any, fn: string) {
    dispatch('updateFnPackage')
    commit('selectFunction', fn)
  },
  updateFnPackage ({ dispatch, state }: any) {
    const fnObject = state.all.find(
      (e: Function) => e.metadata.name === state.current
    )

    if (fnObject) {
      dispatch('packages/getPackage', fnObject.spec.package.packageref, { root: true })
    }
  }
}

const mutations = {
  setFunctions (state: any, functions: unknown) {
    state.all = functions
  },

  selectFunction (state: any, fn: string) {
    state.current = fn
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
